import { UI } from '../lib/ui.js'
export class Icon {
    constructor(icon = null,attr = null){
        this.element = document.createElement('i')
        if(icon) this.set(icon,attr)
        return this.get()
        
    }
    /**
     * 
     * @param {*} icon 
     * @param {*} attr 
     */
    set(icon,attr) {
        if(icon.includes('-'))
            this.element.setAttribute('class',`fa-${icon.split('-')[0]} fa-${icon.split('-')[1]}`)
        else
            this.element.setAttribute('class',`fa-regular fa-${icon}`)
        if(attr){
           
                Object.keys(attr).forEach((key)=>{
                    if(key === 'class'){
                        this.element.classList.add(attr[key])
                    }else{
                        this.element.setAttribute(key,attr[key])
                    }
                    
                })
            
            
        }
            
    }
    /**
     * 
     *  @returns {HTMLElement} 
     */
    get() {
        return this.element
    }
}